import { render } from "./TeamingBadge.vue?vue&type=template&id=6832040c&scoped=true"
import script from "./TeamingBadge.vue?vue&type=script&lang=js"
export * from "./TeamingBadge.vue?vue&type=script&lang=js"

import "./TeamingBadge.vue?vue&type=style&index=0&id=6832040c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6832040c"

export default script